module.exports = __webpack_public_path__ + "static/img/gptModel52.cdcc5ae3.png";